import { useState, useRef, useEffect } from "react";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import buyModuleService from "../../services/BuyModule-service/buy-module-service";
import { Skeleton } from "primereact/skeleton";
const PropertyTypeSelect = ({ seletedFilter, buyFilterUpdate }) => {
  const [propertyType, setPropertytype] = useState([]);
  const [bhkType, setBhkTypes] = useState([]);
  const [propertyTypeErorr, setPropertytypeError] = useState("");
  const [bhktypeError, setBhkTypeError] = useState("");
  const [propertyTypeLoading, setpropertyTypeLoading] = useState(false);
  const [allbhkLoading, setAllbhkLoading] = useState(false);

  // here we calling property type and bhk type from backend
  useEffect(() => {
    const fetchpropertyBhkDetails = async () => {
      setpropertyTypeLoading(true);
      setAllbhkLoading(true);
      try {
        const [propertyTypeResponse, bhkTypeResponse] = await Promise.all([
          buyModuleService.allPropertyType(),
          buyModuleService.allbhk(),
        ]);
        setPropertytype(propertyTypeResponse.data?.result || []);
        setBhkTypes(bhkTypeResponse.data?.result || []);
      } catch (error) {
        setPropertytypeError("Failed to load property types");
        setBhkTypeError("Failed to load BHK types");
      } finally {
        setpropertyTypeLoading(false);
        setAllbhkLoading(false);
      }
    };
    fetchpropertyBhkDetails();
  }, []);

  const updatedSelectedFilter = (key, value) => {
    buyFilterUpdate(key, value);
  };

  // to open the model when user clicks
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="buy-module-dropdown custom-propertyType-dropdown"
      ref={dropdownRef}
    >
      <div
        className="headLabelName d-flex justify-content-between"
        onClick={toggleDropdown}
      >
        <span>Property Type</span>
        <span>
          <FontAwesomeIcon
            icon={isOpen ? faChevronUp : faChevronDown}
            className="toggle-icon"
          />
        </span>
      </div>

      {isOpen && (
        <div className="property-dropdown-modal ">
          <div className="buy-module property-type-select">
            <div className="left-side">
              <div className="Apartment-type">
                <h4>
                  <span>Apartment Type</span>
                </h4>
                <div className="options">
                  <ul>
                    {["Residential", "Commercial", "Mixed Usage"].map(
                      (type) => (
                        <li
                          className={
                            seletedFilter.type === type ? "active" : ""
                          }
                          onClick={() => updatedSelectedFilter("type", type)}
                        >
                          {type}
                        </li>
                      )
                    )}
                    {/* <li className="active" >Residential</li>
                    <li>Commercial</li> */}
                  </ul>
                </div>
              </div>

              <div className="Property-type">
                <h4>
                  <span>Property Type</span>
                </h4>
                <div className="options">
                  {propertyTypeLoading ? (
                    <div className="d-flex gap-1">
                      <Skeleton
                        width="4rem"
                        height="2rem"
                        borderRadius="16px"
                      ></Skeleton>
                      <Skeleton
                        width="4rem"
                        height="2rem"
                        borderRadius="16px"
                      ></Skeleton>
                      <Skeleton
                        width="4rem"
                        height="2rem"
                        borderRadius="16px"
                      ></Skeleton>
                    </div>
                  ) : propertyType.length <= 0 ? (
                    <ul>
                      <li className="d-flex gap-1 align-items-center">
                        <FontAwesomeIcon
                          icon={faTriangleExclamation}
                          style={{ color: "#f59e0b" }}
                        />
                        No Property Type Found
                      </li>
                    </ul>
                  ) : (
                    <ul>
                      {propertyType.map((type) => (
                        <li
                          className={
                            seletedFilter.propertyType === type.propertyType
                              ? "active"
                              : ""
                          }
                          onClick={() =>
                            updatedSelectedFilter(
                              "propertyType",
                              type.propertyType
                            )
                          }
                        >
                          {type.propertyType}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            <div className="right-side">
              <div className="BedRoom-bhk">
                <h4>
                  <span>Bedrooms / BHK</span>
                </h4>
                <div className="options">
                  {allbhkLoading ? (
                    <div className="d-flex gap-1">
                      <Skeleton
                        width="4rem"
                        height="2rem"
                        borderRadius="16px"
                      ></Skeleton>
                      <Skeleton
                        width="4rem"
                        height="2rem"
                        borderRadius="16px"
                      ></Skeleton>
                      <Skeleton
                        width="4rem"
                        height="2rem"
                        borderRadius="16px"
                      ></Skeleton>
                    </div>
                  ) : bhkType.length <= 0 ? (
                    <ul>
                      <li className="d-flex gap-1 align-items-center">
                        <FontAwesomeIcon
                          icon={faTriangleExclamation}
                          style={{ color: "#f59e0b" }}
                        />
                        No BHK Types Found
                      </li>
                    </ul>
                  ) : (
                    <ul>
                      {bhkType.map((type) => (
                        <li
                          className={
                            seletedFilter.bhk === type.bhkType ? "active" : ""
                          }
                          onClick={() =>
                            updatedSelectedFilter("bhk", type.bhkType)
                          }
                        >
                          {type.bhkType}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>

              <div className="status">
                <h4>
                  <span>Status</span>
                </h4>
                <div className="options">
                  <ul>
                    {["Ready To Move", "Under Construction"].map((type) => (
                      <li
                        className={
                          seletedFilter.status === type ? "active" : ""
                        }
                        onClick={() => updatedSelectedFilter("status", type)}
                      >
                        {type === "Ready To Move" && "Ready"}
                        {type === "Under Construction" && "Under Construction"}
                      </li>
                    ))}
                    {/* <li className="active">Ready</li>
                    <li>Under Construction</li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertyTypeSelect;
